module.exports = __webpack_public_path__ + "img/12.641a7712.svg";